export default __webpack_public_path__ + "static/media/Newton-documentation.5b9a239c.md";